import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { selectMixedContentFilters } from '~src/spacesPlatform/selectors/ContentFilterSelectors';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { updateTotalUserCountForServerUserSpace } from '~src/userManagement/sagas/ServerUserSpaceSagas';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { AllServerUsersAndIdentitiesSpace,AllServerUsersAndIdentitiesSpaceDispatchProps,AllServerUsersAndIdentitiesSpaceOwnProps, AllServerUsersAndIdentitiesSpaceStateProps } from './AllServerUsersAndIdentitiesSpace';

const mapStateToProps: MapStateToProps<AllServerUsersAndIdentitiesSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  mixedContentFilterMap: selectMixedContentFilters(state)
});

const mapDispatchToProps: MapDispatchToProps<AllServerUsersAndIdentitiesSpaceDispatchProps> = (dispatch) => bindActionCreators({
    requestSpaceContents,
    updateBreadcrumbs,
    updateTotalUserCountForServerUserSpace
  }, dispatch);

export const ConnectedAllServerUsersAndIdentitiesSpace: React.ComponentClass<AllServerUsersAndIdentitiesSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllServerUsersAndIdentitiesSpace);
